
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.75 5C23.993 5 25 5.895 25 7v18c0 1.105-1.007 2-2.25 2H9.25C8.007 27 7 26.105 7 25V7c0-1.105 1.007-2 2.25-2h13.5zm.107 1H9.143c-.586 0-1.07.386-1.135.883L8 7v18c0 .513.441.936 1.01.993l.133.007h13.714c.586 0 1.07-.386 1.135-.883L24 25V7c0-.513-.441-.936-1.01-.993L22.857 6zM21.25 8a.75.75 0 110 1.5.75.75 0 010-1.5zM16 10a7 7 0 110 14 7 7 0 010-14zm0 1a6 6 0 100 12 6 6 0 000-12zm-.714 3.25a.5.5 0 01.05.64l-.058.068-.434.424a.89.89 0 00.004 1.258c.707.702.756 1.818.14 2.578l-.116.13-.513.53a.5.5 0 01-.775-.627l.057-.07.514-.53a.927.927 0 00.07-1.208l-.082-.094a1.89 1.89 0 01-.124-2.544l.135-.147.425-.415a.5.5 0 01.707.008zm3 0a.5.5 0 01.05.64l-.058.068-.434.424a.89.89 0 00.004 1.258c.707.702.756 1.818.14 2.578l-.116.13-.513.53a.5.5 0 01-.775-.627l.057-.07.514-.53a.927.927 0 00.07-1.208l-.082-.094a1.89 1.89 0 01-.124-2.544l.135-.147.425-.415a.5.5 0 01.707.008zM12.5 8a.5.5 0 110 1h-2a.5.5 0 110-1h2z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    